import { Icon } from "@/components/ui/Icon";

export type OptionProps = {
  image?: any;
  text: string;
  value: string;
  type?: "MobilePhone" | "Email";
  onClick: () => void;
};

export default function Option(props: OptionProps) {
  const ariaLabel = `Se pretende que o código de segurança seja enviado para o ${props.type === "MobilePhone" ? "telemóvel" : "email"} ${props.text}, selecione esta opção`;
  return (
    <div role="button" className="py-12 px-13 text-[var(--on-surface-variant)] flex w-full cursor-pointer justify-center items-center font-bold" aria-label={ariaLabel} onClick={props.onClick}>
      <div aria-hidden className="flex gap-8 items-center">
        {props.type && <Icon size="xl" className="text-[var(--on-surface-variant)]" name={props.type === "MobilePhone" ? "StreamlineDevicesPhoneHandHold1Bold" : "StreamlineEmailsEnvelopeRegular"} />}
        {props.image && <props.image className="w-20" />}
        {props.text}
        <Icon
          size="sm"
          className="arrow text-[var(--on-surface-variant)]"
          name="StreamlineArrowsArrowRight1Regular" />
      </div>
    </div>
  );
}
